// extracted by mini-css-extract-plugin
export default {"container":"Cj-z","bubbleNav":"Dj-z","graphic":"Ej-z","contact":"Fj-z"};